import UserList from "@/features/users/ui/user-list";

export default function Users() {
  {
    return <UserList />;
  }
}
